export const imageBadges = ({ isMobile, _containerHeight, isDesktop }) => {
  return {
    display: "flex",
    // flexDirection: containerHeight <= 780 && isDesktop ? "row" : "column",
    flexDirection: isDesktop ? "row" : "column",
    justifyContent: "center",
    gap: isMobile ? "10px" : "12px",
    width: isMobile ? "60px" : "100px",

    svg: {
      width: "25px",
      height: "25px",
      bottom: "-10px",
      position: "absolute",
    },
  };
};

export const imageBadge =
  ({ backgroundUrl }) =>
  ({ isMobile }) => ({
    width: isMobile ? "60px" : "85px",
    height: isMobile ? "60px" : "85px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "background",
    border: "solid 1px",
    borderColor: "text",
    borderRadius: "10000px",
    backgroundSize: "contain",
    backgroundPosition: "50% 50%",
    backgroundRepeat: "no-repeat",
    backgroundImage: `url(${backgroundUrl})`,
    flexGrow: 0,
    flexShrink: 0,
  });
